<template>
  <section :id="sectionId" class="dashboard-section">
    <div class="section-header">
      <h2 class="section-title">{{ title }}</h2>
      <button type="button" class="btn-filters" @click="toggleFilters">
        {{ filtersOpen ? "Hide Filters" : "Filters" }}
        <span v-if="filterCount" class="filter-count">{{ filterCount }}</span>
      </button>
    </div>
    <DashboardFilterChips :chips="chips" @remove="$emit('remove', $event)" />
    <div v-show="filtersOpen" class="section-filters">
      <div class="section-filter-fields">
        <slot name="filters" />
      </div>
      <div class="section-filter-actions">
        <button type="button" class="btn-apply" @click="applyFilters">Apply</button>
        <button type="button" class="btn-reset" @click="resetFilters">Reset</button>
        <button type="button" class="btn-reset" @click="cancelFilters">Cancel</button>
      </div>
    </div>
    <div v-if="loading" class="section-loading">Loading charts...</div>
    <div v-else class="section-body">
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DashboardFilterChips from "./DashboardFilterChips.vue";

export default defineComponent({
  name: "DashboardSection",
  components: { DashboardFilterChips },
  props: {
    sectionId: { type: String, required: true },
    title: { type: String, required: true },
    loading: { type: Boolean, default: false },
    chips: { type: Array, default: () => [] },
    filterCount: { type: Number, default: 0 },
  },
  emits: ["open", "apply", "reset", "cancel", "remove"],
  data() {
    return {
      filtersOpen: false,
    };
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    toggleFilters() {
      if (this.filtersOpen) {
        this.cancelFilters();
        return;
      }
      this.$emit("open");
      this.filtersOpen = true;
    },
    applyFilters() {
      this.$emit("apply");
      this.filtersOpen = false;
    },
    resetFilters() {
      this.$emit("reset");
      this.filtersOpen = false;
    },
    cancelFilters() {
      this.$emit("cancel");
      this.filtersOpen = false;
    },
    onKeydown(event: KeyboardEvent) {
      if (event.key === "Escape" && this.filtersOpen) {
        this.cancelFilters();
      }
    },
  },
});
</script>
